import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  tabsRoot: {
    display: 'flex',
  },
  tabRoot: {
    flex: 1,
  },
  tab: {
    padding: 10,
  },
  mt20: {
    marginTop: 20,
  },
  title: {
    margin: 0,
    padding: 0,
    marginBottom: 20,
    fontSize: 16,
    fontWeight: 400,
    color: theme.custom.darkBlue,
    textAlign: 'center',
  },
}));
